import AirDatepicker, {AirDatepickerLocale} from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';

import Component from '../../component/component';
import Icon from '../../icon/icon';

import './datepicker.scss';

export interface IDatepickerLocals {
    [key: string]: AirDatepickerLocale;
}

export default class Datepicker extends Component {
    static initSelector: string = '.datepicker-field';

    private input: JQuery;
    private datePicker: AirDatepicker;

    // air-datepicker's built-in default locale is Russian, so the current site
    // language locale (localized server-side) must always be passed explicitly
    static get locale(): Partial<AirDatepickerLocale> | null {
        const locale: Partial<AirDatepickerLocale> = window.gotoAndPlay?.datepickerLocale;

        return locale?.months?.length ? locale : null;
    }

    constructor(target: HTMLElement) {
        super(target);
        this.input = this.element.find('input');
        this.init();
    }

    init(): void {
        const nextArrow: string = Icon.render('chevron-right', 'datepicker__arrow datepicker__arrow--next');
        const prevArrow: string = Icon.render('chevron-left', 'datepicker__arrow datepicker__arrow--prev');
        const locale: Partial<AirDatepickerLocale> | null = Datepicker.locale;

        if (this.input.length) {
            this.datePicker = new AirDatepicker(this.input.get(0) as HTMLInputElement, {
                dateFormat: locale?.dateFormat ? locale.dateFormat : 'dd/MM/yyyy',
                ...(locale ? {locale} : {}),
                navTitles: {
                    days: 'MMM yyyy',
                    months: 'yyyy',
                    years: 'yyyy - yyyy',
                },
                nextHtml: nextArrow,
                onSelect: () => this.input.trigger('change'),
                position: 'bottom left',
                prevHtml: prevArrow,
            });
        }
    }

}
